import './App.css';
import {BrowserRouter} from "react-router-dom";
import AppRouter from "./routes/routes";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import { initMercadoPago } from '@mercadopago/sdk-react';
import { Toaster } from 'sonner';

initMercadoPago("TEST-343c8e7f-85af-477f-adbb-4893eecf739e", {
  locale: 'pt-BR'
})

function App() {
  return (

    <BrowserRouter>
      <ScrollToTop />
      <AppRouter/>
      <Toaster />
    </BrowserRouter>
   
  )
}

export default App
